/* globals $:false */

import utils from '@cob/ui-genesis/cob.utils.js';

// Component capable of handling only link fields
//
// args:
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A space separated list of css classes to add to the link
// * `text`: the text of the link. Defaults to "Link".
// * `initialHref`: The initial href
// * `encode`: flag for encoding the url (default is true)
//
var Link = function(core, confs) {

    var _$link,
        _lastValue;

    var _confs = {
        id: core.locallyUniqueId(),
        cssClasses: undefined,
        text: "Link",
        initialHref: undefined,
        encode: true
    };

    if (confs) {
        utils.extend(_confs, confs, true);
    }

    var _render = function() {
        var $html = $([
            '<div class="inline">',
            '<a id="f' + _confs.id + '" class="link field-value cob-field-value" target="_blank">',
            _confs.text,
            '</a>',
            '</div>'
        ].join(''));

        _$link = $html.find("a");

        if (_confs.cssClasses) {
            _$link.addClass(_confs.cssClasses);
        }

        if (!_lastValue) {
            _$link.attr("href", _confs.initialHref);

        } else {
            _$link.attr("href", _confs.encode ? encodeURI(_lastValue) : _lastValue);
        }

        return $html;
    };

    var _noop = function() {};

    return {
        render: _render,
        destroy: _noop,

        clearError: _noop,
        showError: _noop,

        // a link is never editable, so there is nothing to disable or enable (it stays clickable)
        disableSelf: _noop,
        enableSelf: _noop,

        setValue: function(value) {
            _lastValue = Array.isArray(value) ? value[0] : value;

            if (_$link) {
                _$link.attr("href", _confs.encode ? encodeURI(value) : value);
            }
        },
        getValue: function() {
            return _lastValue || _confs.initialHref;
        },

        isEnabled: function () {
            return false;
        }
    }
};

export default Link;
